import React from 'react'
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
// import YouTubeIcon from '@mui/icons-material/YouTube';

const AltNavbar = () => {
    return (
        <nav className='navbar'>
            <div className="logo"><a href="/"><img src="./logo_black.png" alt="Driveplus logo" width="225px" /></a></div>

            <div className="social-icons">
                {/* <Link to="/signin" className="sign-in">Login</Link> */}
                <a href="https://twitter.com" rel="noopener" target="_blank"><TwitterIcon /></a>
                <a href="https://instagram.com" rel="noopener" target="_blank"><InstagramIcon /></a>
                {/* <YouTubeIcon /> */}

                {/* <Link to="/register" className="register">Create Account</Link> */}
            </div>

        </nav>
    )
}

export default AltNavbar